import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorHeading: {
		id: 'navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-heading',
		defaultMessage: 'Something went wrong',
		description: 'Title for error message when encountering an error with the sidebar navigation',
	},
	errorBody: {
		id: 'navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-body',
		defaultMessage: 'Try refreshing or navigating to another page.',
		description:
			'Description for error message when encountering an error with the sidebar navigation',
	},
});
